// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deleteButton {
  background-color: white;
  color: red;
  position: absolute;
  bottom: 10px;
  left: 10px;
  z-index: 10;
}

.editButton {
  background-color: white;
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 10;
}
`, "",{"version":3,"sources":["webpack://./src/app/field/line/tree/truffle/truffle.component.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;AACb","sourcesContent":[".deleteButton {\n  background-color: white;\n  color: red;\n  position: absolute;\n  bottom: 10px;\n  left: 10px;\n  z-index: 10;\n}\n\n.editButton {\n  background-color: white;\n  position: absolute;\n  bottom: 10px;\n  right: 10px;\n  z-index: 10;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
